import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

import { useUser } from "components/UserProvider";

const UserAuthCheck: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isPending, user } = useUser();

  const isVerified = !!user?.is_verified;

  useEffect(() => {
    if (!isPending && !isVerified) {
      void navigate("/login", {
        replace: true,
        state: { from: location },
      });
    }
  }, [isPending, isVerified, location, navigate]);

  if (isPending || !isVerified) {
    return null;
  }

  return <Outlet />;
};

export default UserAuthCheck;
